'use strict';

import {easeOutExpo} from "../../../_js/common/_util";

export default class Sidebar {
  constructor() {
    $('.region-sidebar-first .menu--secondary .secondary-nav__section-title').after(`<button class="menu--toc -js-toggle-toc" type="button">
                                                                        In this section
                                                                    </button>`);

    $('.-js-toggle-toc').on('click', function (e) {
      e.preventDefault();

      $(this).toggleClass('-active')
          .next().stop().clearQueue().slideToggle(easeOutExpo);
    });

    $('.region-sidebar-first .menu--secondary').on('keydown', '.has-sub > a', function (e) {
      const $this = $(this);
      const $parent = $this.parent();

      if (e.keyCode == '13') {
        if (!$parent.hasClass('-hover')) {
          e.preventDefault();
        }

        $parent
            .addClass('-hover');
      }
    }).on('keydown', 'a', function (e) {
      const $this = $(this);
      const $closest = $this.closest('.has-sub');

      if (e.keyCode == '27') {
        if (!$closest.hasClass('-hover')) {
          e.preventDefault();
        }

        $closest
            .removeClass('-hover');
      }
    }).on('focus', 'a', function (e) {
      const $this = $(this);
      const $parent = $this.parent();
      const $hoverLength = $this.closest('.-hover').length;

      if (e.shiftKey) {
        $this.parent().next().find('-hover').removeClass('-hover');
      }

      if ($hoverLength == 0 || $hoverLength == 1) {
        $parent.prev().removeClass('-hover')
            .find('.-hover').removeClass('-hover');
      }
    });
  }
}
